enum Step {
    One = 1,
    Two,
    Three,
    Four,
    Five,
    Six
}

export default Step;